import { createContext } from 'react';

// Scope navigation selectors without coupling tree nodes to page routes.
export const TreeTestIdContext = createContext<string | undefined>(undefined);